<span class="base-spinner" [style.--scale]="scale()" role="status" [attr.aria-label]="ariaLabel()">
    @switch (type()) {
    @case ('default') {
    <span class="spinner-root">
        <div class="lds-default">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @case ('dual-ring') {
    <span class="spinner-root">
        <div class="lds-dual-ring"></div>
    </span>
    }
    @case ('facebook') {
    <span class="spinner-root">
        <div class="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @case ('ring') {
    <span class="spinner-root">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @case ('ellipsis') {
    <span class="spinner-root">
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @case ('grid') {
    <span class="spinner-root">
        <div class="lds-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @case ('ripple') {
    <span class="spinner-root">
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </span>
    }
    @default {
    <span class="spinner-root">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </span>
    }
    }
</span>